import React, { useMemo } from "react";

// Animated rising bubbles for hero background
export const RisingBubbles = ({ count = 14 }) => {
  const bubbles = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const size = Math.random() * 80 + 24; // 24 - 104 px
      const left = Math.random() * 100;
      const delay = Math.random() * 12;
      const duration = Math.random() * 14 + 14; // 14-28s
      return { id: i, size, left, delay, duration };
    });
  }, [count]);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {bubbles.map((b) => (
        <span
          key={b.id}
          className="bubble"
          style={{
            left: `${b.left}%`,
            bottom: `-${b.size}px`,
            width: `${b.size}px`,
            height: `${b.size}px`,
            animationDuration: `${b.duration}s`,
            animationDelay: `${b.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export const StaticBubbles = ({ items }) => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {items.map((b, i) => (
        <span
          key={i}
          className="bubble-static"
          style={{
            top: b.top,
            left: b.left,
            right: b.right,
            bottom: b.bottom,
            width: b.size,
            height: b.size,
            animationDelay: `${i * 0.7}s`,
          }}
        />
      ))}
    </div>
  );
};
